module.exports = __webpack_public_path__ + "img/failed.425109b2.png";